/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Header } from "../../components/header";
import { NavLink } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { Routes } from "../../AppRoutes";
import "./statistics.scss";
import SpeedDialAction from "devextreme-react/speed-dial-action";
import { Position } from "devextreme-react/data-grid";

const MenuWithChildren = (props: any) => {
  const { onClick, show, menu, childrens } = props;
  return (
    <div>
      <a onClick={onClick} role="presentation">
        {menu.icon}
        {menu.title}
      </a>
      <Collapse in={show}>
        <div className="pl-4 ml-1">
          {childrens.map((item: any) => (
            <NavLink to={item.path} key={item.path}>
              {item.title}
            </NavLink>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

const InfoTechnologyProcess = () => {
  const [show, set] = useState(true);
  return (
    <MenuWithChildren
      menu={Routes.statistic}
      // childrens={[Routes.statistics, Routes.userDocument, Routes.readStatisticDocument, Routes.statisticDocumentByViagsPage, Routes.statisticDistributionDocumentPage, Routes.quoteStatisticDocumentPage, Routes.processReferenceDocumentPage]}
      childrens={[
        Routes.statistics,
        Routes.userDocument,
        Routes.readStatisticDocument,
        Routes.statisticDistributionDocumentPage,
        Routes.quoteStatisticDocumentPage,
        Routes.versionDocumentContentPage,
      ]}
      show={show}
      onClick={() => set(!show)}
    />
  );
};

export const withStatisticWapper = (Component: any) => (props: any) => {
  const [showMenu, setShowMenu] = useState(true);

  const onHideMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      <Header />
      <>
        <div className={showMenu ? "Menu__Navgiator" : "Menu__Navgiator-hide"}>
          <InfoTechnologyProcess />
        </div>
        <SpeedDialAction
          icon={showMenu ? "hidepanel" : "showpanel"}
          label={showMenu ? "Ẩn Menu" : "Hiện Menu"}
          index={1}
          onClick={onHideMenu}
        >
          <Position at="right top" offset="-16 120" />
        </SpeedDialAction>
        <div className={showMenu ? "Main__Content" : "Main__Content-hide"}>
          <Component {...props} />
        </div>
      </>
    </>
  );
};
